import { Grid, Typography } from '@material-ui/core';
import React, { useCallback } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import styled from 'styled-components';

import useResetPassword from 'core/hooks/useResetPassword';
import resetPasswordSchema, { ResetPasswordSchema } from 'core/schemas/resetPassword';
import {
  Form,
  FormSubmitHandler,
  InputField,
  SubmitButton,
} from 'Elements/Form';

const Container = styled.div`
  padding: ${props => props.theme.spacing(6)}px;
`;

export default function WelcomeCustomer({
  location,
  match,
  history
}: RouteComponentProps<{ token: string }>) {
  const reset = useResetPassword();

  const onSubmit: FormSubmitHandler<ResetPasswordSchema> = useCallback(
    (payload, form) =>
      reset(payload)
        .then(() => history.push('/welcome/customer'))
        .catch(form.setErrors),
    [history, reset]
  );

  const email = new URLSearchParams(location.search).get('email');

  return (
    <Form
      onSubmit={onSubmit}
      initialValues={{
        email: email,
        token: match.params.token
      }}
      validationSchema={resetPasswordSchema}
    >
      <Grid container component={Container} direction="column" spacing={4}>
        <Grid item>
          <Typography variant="h1">
            Tervetuloa rengastallin käyttäjäksi!
          </Typography>
        </Grid>

        <Grid item>
          <Typography color="textSecondary">
            Viimeistele tunnuksesi antamalla salasana, jolla pääset kirjautumaan
            mobiilisovellukseen.
          </Typography>
        </Grid>

        {email === null && (
          <Grid item>
            <InputField
              type="email"
              name="email"
              autoFocus
              placeholder="Sähköpostiosoitteesi"
              margin="none"
            />
          </Grid>
        )}

        <Grid item>
          <InputField
            type="password"
            name="password"
            autoFocus={email !== null}
            placeholder="Syötä salasana"
            margin="none"
          />
        </Grid>

        <Grid item>
          <InputField
            type="password"
            name="password_confirmation"
            placeholder="Syötä salasana uudelleen"
            margin="none"
          />
        </Grid>

        <Grid item>
          <SubmitButton variant="contained" color="primary" fullWidth>
            Aktivoi
          </SubmitButton>
        </Grid>
      </Grid>
    </Form>
  );
}
